(()=>{
  const bind=()=>{
    document.querySelectorAll('[data-pippa-sticky]').forEach(sticky=>{
      if(sticky.dataset.pippaV5Sticky)return;
      sticky.dataset.pippaV5Sticky='1';
      let dismissed=false;
      const hero=document.querySelector('.home-hero');
      const main=document.querySelector('#MainContent');
      const update=()=>{
        if(dismissed||!sticky.isConnected)return;
        const pageY=Math.max(window.scrollY||0,document.documentElement.scrollTop||0,document.body.scrollTop||0,main?.scrollTop||0);
        const heroPassed=hero ? hero.getBoundingClientRect().bottom<Math.min(window.innerHeight*.88,760) : pageY>=320;
        sticky.hidden=!(heroPassed||pageY>=320);
      };
      if(hero&&'IntersectionObserver'in window){
        const observer=new IntersectionObserver(update,{threshold:[0,.08,.5,1]});
        observer.observe(hero);
      }
      window.addEventListener('scroll',update,{passive:true});
      document.addEventListener('scroll',update,{passive:true,capture:true});
      window.addEventListener('resize',update,{passive:true});
      sticky.querySelector('[data-pippa-sticky-close]')?.addEventListener('click',()=>{dismissed=true});
      requestAnimationFrame(update);
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',bind):bind();
  document.addEventListener('shopify:section:load',bind);
})();
